import { useEffect } from "react";
import { Box, Container, Stack, Typography } from "@mui/material";
import { useAppDispatch, useAppSelector } from "@store/hooks";
import { addUserInfo } from "@store/slices/authSlice";
import { AccountPanel } from "./AccountPanel";
import { ProfilePanel } from "./ProfilePanel";
import { SecurityPanel } from "./SecurityPanel";

const ProfileScreen = () => {
  const dispatch = useAppDispatch();
  const { userId } = useAppSelector((state) => state.user);

  // Refresh /users/me on mount so tier/source/org chips don't lag a
  // stale Redux cache. The auth slice is non-persisted but useEffect
  // wins races against the initial hydrate.
  useEffect(() => {
    if (userId) {
      dispatch(addUserInfo(userId));
    }
  }, [dispatch, userId]);

  return (
    <Box>
      <Container maxWidth="md" sx={{ py: 4 }}>
        <Typography variant="h4" sx={{ mb: 1 }}>
          Settings
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>
          Manage your account, profile, and security preferences.
        </Typography>

        <Stack spacing={3}>
          <AccountPanel />
          <ProfilePanel />
          <SecurityPanel />
        </Stack>
      </Container>
    </Box>
  );
};

export default ProfileScreen;
